<template>
  <div class="google-btn-container" @click="clicked">
    <img src="/static/img/btn_google_dark_normal_ios.svg" class="logo"/>
    <div class="txt noselect">
      <span style="font-size: 0.875rem;">Sign in with Google</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sign-in-with-google',
  methods: {
    clicked() {
      this.$emit('clicked')
    }
  }
}
</script>
<style scoped>

.google-btn-container {
  padding: 0px;
  display: inline-flex;
  background-color: #4285f4;
  border-radius: 2px;
  cursor: pointer;
  width: 220px;
}

.google-btn-container:hover {
  box-shadow: inset 0 0 0 10em rgba(255, 255, 255, 0.15);
}

.logo {
  height: 38px;
  width: 38px;
  flex-shrink: 0;
}

.txt {
  color: white;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                            supported by Chrome, Edge, Opera and Firefox */
}
</style>